import { FeatureFunction } from "../feature-function";
import { Injectable } from "@angular/core";

@Injectable()
export class TrueFunction implements FeatureFunction<boolean> {
    static readonly reference = 'featureExists';

    public apply(): Promise<boolean> {
        return Promise.resolve(true);
    }
}
